export default __webpack_public_path__ + "static/media/97_header_expense.06a3815c.png";